import HolderFields from './HolderFields'

// function HolderFields() {
//   return (
//     <ABTest flag={FeatureFlagKey.ExpressCheckout} fallback={<HolderFieldsControl />}>
//       <ABTest.Option value="test">
//         <HolderFieldsTestGroup />
//       </ABTest.Option>
//       <ABTest.Option value="control">
//         <HolderFieldsControl />
//       </ABTest.Option>
//     </ABTest>
//   )
// }

export default HolderFields
